import Label from 'components/Label'
import View from 'components/View'
import React from 'react'
import { ReactComponent as ArrowDown } from 'assets/arrow-down.svg'
import { ReactComponent as Check } from 'assets/check-icon.svg'
import { OFFERS_DROPDOWN_ITEMS } from '..'

const ProfileOffersDropdown = ({ open, selectedItem, setItem, setOpen }) => {
  return (
    <View direction="column" zIndex="100">
      <View
        padding="0.5rem"
        cursor="pointer"
        alignItems="center"
        gap="0.5rem"
        onClick={() => setOpen(!open)}
        onBlur={() => setOpen(false)}
      >
        <Label color="black">{selectedItem}</Label>
        <ArrowDown />
      </View>
      {open && (
        <View
          width="fit"
          position="absolute"
          top="2.5rem"
          direction="column"
          left="-0.9rem"
          border="1px solid #E1E1E8"
          borderRadius="6px"
          background="#fff"
        >
          {Object.values(OFFERS_DROPDOWN_ITEMS).map(item => (
            <View
              key={item}
              direction="row"
              alignItems="center"
              cursor="pointer"
              gap="1rem"
              width="100%"
              padding="1rem"
              hoverBackground="#f3f3fa"
              transition="0.1s ease-in-out"
              onClick={() => {
                setItem(item)
                setOpen(false)
              }}
            >
              {item}
              {selectedItem === item && <Check />}
            </View>
          ))}
        </View>
      )}
    </View>
  )
}

export default ProfileOffersDropdown
